import React from "react";
import Catia1 from "../assets/img/pageimages/Catia1.jpeg";
import Catia2 from "../assets/img/pageimages/Catia2.jpeg";

const Catia = () => {
  return (
    <div className="catia-wrapper">
      <style>{`
        .catia-wrapper {
          background-color: #f9fafb;
          color: #1f2937;
          font-family: 'Poppins', sans-serif;
          padding: 3rem 1rem;
        }

        .catia-header {
          padding: 4rem 0;
          text-align: center;
         
        }

        .catia-header h1 {
          color: #7620ff;
          margin-bottom: 2rem;
           font-size:2.0rem;
        }

        .catia-header p {
          margin: 0 auto;
          max-width:80%;
        }

        .catia-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin: 0rem auto;
          max-width: 1000px;
        }

        .catia-gallery img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          border-radius: 1rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }

     

        .content-wrapper {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto 4rem;
          padding: 2rem 1rem;
        }

        @media(min-width: 1024px) {
          .content-wrapper {
            flex-direction: row;
            align-items: flex-start;
          }
        }

        .left, .right {
          flex: 1;
        }

        .section-title {
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .section-title.green {
          color:#fdba00;
        }

        .section-title.purple {
          color: #fdba00;
        }

        .section-title.orange {
          color: #fdba00;
        }

        .feature-box, .learn-box {
          background: white;
          border-radius: 1rem;
          padding: 2rem;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-bottom: 1.5rem;
        }

        .feature-box ul {
          padding-left: 1.25rem;
          color: #374151;
          list-style-type: disc;
          line-height: 1.6;
        }

        .learn-box a {
          display: block;
          background: #7620ff;
          color: white;
          font-weight: bold;
          text-align: center;
          padding: 1rem;
          border-radius: 0.75rem;
          text-decoration: none;
          margin-bottom: 1rem;
          transition: background 0.3s;
        }

        .learn-box a:hover {
          background: #2563eb;
        }
      `}</style>

      {/* Header */}
      <section className="catia-header">
        <h1>Explore CATIA</h1>
        <p>
          CATIA is a comprehensive software suite by Dassault Systèmes, used for CAD, CAE, and CAM.
          It empowers engineers to design, simulate, and manufacture products across various industries.
        </p>
      </section>

      {/* Image Gallery */}
      <section className="catia-gallery">
        <img src={Catia1} alt="CATIA Use Case 1" />
        <img src={Catia2} alt="CATIA Use Case 2" />
      </section>

      {/* Main Content */}
      <section className="content-wrapper">
        {/* Left Side - Features + Benefits */}
        <div className="left">
          <h2 className="section-title green">Key Features and Capabilities</h2>
          <div className="feature-box">
            <ul>
              <li><strong>3D CAD:</strong> Intricate part and assembly modeling.</li>
              <li><strong>CAE:</strong> Simulate and optimize product performance.</li>
              <li><strong>CAM:</strong> Create manufacturing instructions and simulations.</li>
              <li><strong>PLM:</strong> Supports full product lifecycle.</li>
              <li><strong>Collaboration:</strong> Enables seamless teamwork.</li>
              <li><strong>Industry Modules:</strong> Tailored for aerospace, automotive, etc.</li>
              <li><strong>CATIA V5:</strong> Popular desktop version.</li>
              <li><strong>3DEXPERIENCE:</strong> Cloud-based version accessible via browser.</li>
            </ul>
          </div>

          <h2 className="section-title orange">Benefits of Using CATIA</h2>
          <div className="feature-box">
            <ul>
              <li>Improved design accuracy and detail</li>
              <li>Faster product development cycles</li>
              <li>Better product performance via simulation</li>
              <li>Cost savings by identifying design issues early</li>
              <li>Increased productivity through powerful tools</li>
            </ul>
          </div>
        </div>

        {/* Right Side - Applications + Learn More */}
        <div className="right">
          <h2 className="section-title purple">Applications</h2>
          <div className="feature-box">
            <ul>
              <li>Aerospace: Aircraft, engines, structural components</li>
              <li>Automotive: Vehicles, interiors, exteriors, powertrains</li>
              <li>Consumer Goods: Electronics, appliances</li>
              <li>Industrial Machinery: Equipment and production tools</li>
            </ul>
          </div>

          <div className="learn-box">
            <h2 className="section-title orange">Learn More</h2>
            <a
              href="https://www.3ds.com/products-services/catia/"
              target="_blank"
              rel="noreferrer"
            >
              Official CATIA Website
            </a>
            <a
              href="https://www.3ds.com/support/"
              target="_blank"
              rel="noreferrer"
            >
              CATIA Support & Tutorials
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Catia;
